/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Public_HostInputs */

const cs_settings_office_public_host = /** @type {(inputs: Settings_Office_Public_HostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejná doména webu`)
};

const en_settings_office_public_host = /** @type {(inputs: Settings_Office_Public_HostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public website domain`)
};

/**
* | output |
* | --- |
* | "Public website domain" |
*
* @param {Settings_Office_Public_HostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_public_host = /** @type {((inputs?: Settings_Office_Public_HostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Public_HostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_public_host(inputs)
	return cs_settings_office_public_host(inputs)
});